// src/pages/TestFunctionsPage.js
import React, { useState } from 'react';
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase';

function TestFunctionsPage() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callHelloWorld = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log("Calling helloWorld function in australia-southeast1...");
      
      // Create a reference to your function
      const helloWorldFunction = httpsCallable(functions, 'helloWorld');
      
      // Call the function
      const response = await helloWorldFunction({});
      
      // Handle the result
      console.log("Function response:", response.data);
      setResult(response.data);
    } catch (err) {
      console.error("Error calling function:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <header className="page-header">
        <h1>Cloud Functions Test</h1>
        <p>Test your Gen 2 Cloud Functions deployed in australia-southeast1</p>
      </header>
      
      <div className="card">
        <h2>Test helloWorld Function</h2>
        <p>This will call the <code>helloWorld</code> callable function from your cooc-gen2 codebase.</p>
        
        <button 
          className={`primary-button ${loading ? 'loading' : ''}`}
          onClick={callHelloWorld} 
          disabled={loading}
        >
          {loading ? 'Calling Function...' : 'Call helloWorld Function'}
        </button>
        
        {error && (
          <div className="error-message">
            <strong>Error:</strong> {error}
          </div>
        )}
        
        {result && (
          <div className="result-container">
            <h3>Function Result:</h3>
            <pre className="code-block">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
      </div>
      
      <style jsx>{`
        .page-container {
          padding: 20px;
          max-width: 800px;
          margin: 0 auto;
        }
        
        .page-header {
          margin-bottom: 20px;
        }
        
        .card {
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          padding: 20px;
          margin-bottom: 20px;
        }
        
        .primary-button {
          background-color: #128C7E;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 10px 15px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .primary-button:hover {
          background-color: #0C6B5E;
        }
        
        .primary-button.loading {
          background-color: #cccccc;
          cursor: not-allowed;
        }
        
        .error-message {
          margin-top: 15px;
          padding: 10px;
          background-color: #FFF3F3;
          color: #D32F2F;
          border: 1px solid #FFCDD2;
          border-radius: 4px;
        }
        
        .result-container {
          margin-top: 15px;
        }
        
        .code-block {
          background-color: #F5F5F5;
          padding: 15px;
          border-radius: 4px;
          overflow: auto;
          white-space: pre-wrap;
          word-break: break-word;
        }
      `}</style>
    </div>
  );
}

export default TestFunctionsPage;